// FAZ-53 — Başvuru listesindeki "Kanal" sütununun hücresi.
//
// Sözleşme:
//   • İKON HERKESE görünür — başvurunun halk masasından mı bireysel mi geldiği
//     izne bağlı DEĞİL.
//   • "Kim oluşturdu" bilgisi yalnız izinli kullanıcıya gider. Backend izinsizde
//     `channel_origin: null` döndürür → burada ayrıca izin sorgusu YOK; verinin
//     varlığı tek doğruluk kaynağıdır (frontend'de gizlemek yerine veri gelmez).
//   • İkon tıklaması satır tıklamasını yutar → detay sayfasına gitmez.

import React from "react";

import { getChannelMeta, CHANNEL_HALK_MASASI } from "../icons/channelMeta";
import HoverPopover from "../utils/HoverPopover";

import "./ChannelCell.css";

export default function ChannelCell({ app }) {
  const meta = getChannelMeta(app?.source_channel);
  const origin = app?.channel_origin || null;
  const Icon = meta.Icon;

  const icon = <Icon className={meta.className} aria-hidden="true" />;

  const bireysel = app?.source_channel !== CHANNEL_HALK_MASASI;
  const olusturan = (origin?.full_name || "").trim();

  // Baloncuk HER KANALDA açılır: kanalın kendisi zaten ikondan belli, dolayısıyla
  // adını yazmak bir şey sızdırmaz. İzne bağlı olan tek şey "kim oluşturdu"
  // satırı — o yoksa baloncuk yalnız kanalı anlatır.
  // Kullanıcı kararı: listede BİRİM ve TARİH gereksiz — kim gönderdi yeterli.
  const content = (
    <span className="channel-origin">
      <span className="channel-origin-title">
        {bireysel ? "Bireysel başvuru" : `${meta.label} ile alındı`}
      </span>
      <span className="popover-divider" aria-hidden="true" />

      {bireysel ? (
        <span className="channel-origin-note">
          Vatandaş tarafından doğrudan gönderildi.
        </span>
      ) : origin ? (
        <span className="channel-origin-row">
          <span className="channel-origin-key">Oluşturan</span>
          {olusturan ? (
            /* Kullanıcı kararı: ROL yazılmaz — yalnız kişinin adı. */
            <span className="channel-origin-val">{olusturan}</span>
          ) : (
            <span className="channel-origin-val channel-origin-val--muted">
              Bilinmiyor
            </span>
          )}
        </span>
      ) : (
        <span className="channel-origin-note">
          Halk masası personeli tarafından açıldı.
        </span>
      )}
    </span>
  );

  return (
    <span className="channel-cell">
      <HoverPopover trigger={icon} label={meta.label} content={content} />
    </span>
  );
}
